export enum Variant {
  DEFAULT,
  ADMIN_NEWLY_ADDED,
}
